import { Measures } from "../../../telemetry/Measures";
import { dashboard } from "../../../telemetry/TraceLogging";
import { getResources } from "../../getResources";
import { formatString } from "../../utils/stringUtilities";
import { WidgetApi } from "../orchestrator/WidgetApi";
export class WidgetStatusApi extends WidgetApi {
    constructor(widgetInstance) {
        super(widgetInstance);
        this._lastUpdated = new Date();
        this._showStatus = false;
        this._eventListenersInternal = new Array();
    }
    outlookSignInButtonCallback() {
        if (this._outlookSignInButtonCallback !== undefined) {
            this._outlookSignInButtonCallback();
        }
    }
    showLastUpdated(date) {
        this._lastUpdated = date;
        this._showStatus = true;
        this.fireEventInternal("onShowLastUpdated");
    }
    hideLastUpdated() {
        this._showStatus = false;
        this.fireEventInternal("onHideLastUpdated");
    }
    signedOut() {
        this.fireEventInternal("onSignedOut");
    }
    signedIn() {
        this.fireEventInternal("onSignedIn");
    }
    getStatus() {
        if (this._showStatus) {
            // If last updated duration is < 1hr, show "Xm ago"
            // If last updated duration is >= 1hr, show "Xh ago"
            let lastUpdatedDurationMins = Math.floor((Date.now() - this._lastUpdated.valueOf()) / (60 * 1000));
            return `${lastUpdatedDurationMins < 60
                ? formatString(getResources().WidgetStatusApi_lastUpdatedDuration_Min, {
                    duration: new Intl.NumberFormat().format(lastUpdatedDurationMins),
                })
                : formatString(getResources().WidgetStatusApi_lastUpdatedDuration_Hour, {
                    duration: new Intl.NumberFormat().format(Math.floor(lastUpdatedDurationMins / 60)),
                })} `;
        }
        return "";
    }
    widgetReady() {
        this.statusApiCalled("widgetReady");
        if (this._widgetInstance.widgetState === "error") {
            this._widgetInstance.widgetState = "normal";
        }
    }
    widgetError(message) {
        this.statusApiCalled("widgetError");
        if (this._widgetInstance.widgetState !== "error") {
            this._widgetInstance.widgetErrorStateReason = this._widgetInstance.widgetDefinitionId + ":" + message;
            this._widgetInstance.widgetErrorCode = 2147549183; // E_UNEXPECTED;
            this._widgetInstance.widgetState = "error";
        }
    }
    widgetSignIn(signInButtonClicked) {
        this.statusApiCalled("widgetSignIn");
        this._outlookSignInButtonCallback = signInButtonClicked;
        this.signedOut();
    }
    widgetSignInSuccessful() {
        this.statusApiCalled("widgetSignInSuccessful");
        this.signedIn();
        let authenticatorApi = window.__com_microsoft_dsh_widgetModelApiFactory
            .tryGetApi("authenticator", 1, 1);
        if (authenticatorApi) {
            // Refreshes the page
            authenticatorApi.signInUserAsync("signInButton");
        }
    }
    addStatusEventListenerInternal(listener) {
        this._eventListenersInternal.push(listener);
    }
    removeStatusEventListenerInternal(listener) {
        let index = this._eventListenersInternal.indexOf(listener);
        if (index > -1) {
            this._eventListenersInternal.splice(index, 1);
        }
    }
    fireEventInternal(name) {
        for (let index = 0; index < this._eventListenersInternal.length; index++) {
            if (this._eventListenersInternal[index]) {
                this._eventListenersInternal[index](name);
            }
        }
    }
    statusApiCalled(source) {
        Measures.logEvent(dashboard, "StatusApiCalled", 16777216 /* productAndServicePerformance */, {
            appId: this._widgetInstance.widgetRegistration.appId,
            currentState: this._widgetInstance.widgetState,
            indexedDBInstanceId: this._widgetInstance.instanceId,
            providerId: this._widgetInstance.widgetRegistration.providerId,
            source: source,
            widgetDefinitionId: this._widgetInstance.widgetRegistration.id,
            widgetInstanceId: this._widgetInstance.widgetId,
        });
    }
}
